import Api from '../http.service';
/**
 * get all countries list
 */
export const getAll = () => Api.GET({ url: 'country' });
